import api from '@edu-fe/api'

export default {
  name: 'preferential',

  getInfo: api.create(`/operation/coupon/courses`)
}
